export const MESSAGES_LIST = {
  SELECT_DATA_RISK: {
    title: 'Select data for the calculation',
    message:
      'Choose the data you want to include in the risk calculation in the selector above and click on Calculate.',
  },
  SELECT_DATA: {
    title: 'No data selected',
    message: 'Select the data you want to be displayed in the filters',
  },
  NO_DATA_FOUND: {
    title: 'No data found',
    message: 'No results for the selected token',
  },
};

export const MESSAGES_LIST_EXCHANGE = {
  CONNECT_NEW_ACCOUNT: {
    title: 'Select data for the calculation',
    button: 'Connect to an exchange',
  },
  INVALID_ACCOUNTS: {
    title: 'There are no valid connections',
    message: 'Please refresh your API Key connections or try to connect a new one.',
    button: 'Go to exchange connections',
  },
  ERROR_REQUEST: {
    title: 'An error occurred when calculating your risk',
    message: 'Please recalculate or, if the error persists, try again later.',
    button: 'Recalculate risk',
  },
};

export const PORTFOLIO_MESSAGES = {
  SELECT_DATA_RISK: {
    title: 'Select data for the calculation',
    description:
      'Choose the data you want to include in the risk calculation from the side menu and click on Calculate.',
  },
  NO_DATA_FOUND: {
    title: `You don't have any positions`,
    description: 'Try to select another account',
  },
  NO_AGGREGATED_ACCOUNTS: {
    title: 'Coming soon',
    description: '',
  },
  NO_ACCOUNT_OKX_POSITIONS: {
    title: 'Coming soon',
    description: 'We are currently working on Positions and Orders for OKX accounts',
  },
  NO_ACCOUNT_OKX_TRANSACTIONS: {
    title: 'Coming soon',
    description: 'We are currently working on Transactions for OKX accounts',
  },
  NO_DATA_FOUND_TRANSACTIONS: {
    title: `You don't have any transactions`,
    description: 'Try to select another account',
  },
  NO_DATA_FOUND_FILTER_TRANSACTIONS: {
    title: 'No results for the selected filters',
    description: 'Try to select other options',
  },
  EMPTY_CREDENTIALS: {
    title: 'There are no connected exchanges',
    description: '',
    button: 'Connect to an exchange',
  },
  ERROR_REQUEST_RISK: {
    title: 'An error occurred when calculating your risk',
    description: 'Please recalculate or, if the error persists, try again later.',
    button: 'Recalculate',
  },
  ERROR_REQUEST_PNL: {
    title: 'An error occurred when calculating your PNL',
    description: 'Please recalculate or, if the error persists, try again later.',
    button: 'Recalculate',
  },
  ERROR_REQUEST_TRANSACTIONS: {
    title: 'An error occurred when retrieving your Transactions',
    description: 'Please try again or, if the error persists, come back later.',
    button: 'Try again',
  },
  ERROR_REQUEST_POSITIONS_ORDERS: {
    title: 'An error occurred when retrieving your Positions and Orders',
    description: 'Please try again or, if the error persists, come back later.',
    button: 'Try again',
  },
  ERROR_REQUEST_STRIKE_REPORT: {
    title: 'An error occurred when retrieving your Strike Report',
    description: 'Please try again or, if the error persists, come back later.',
    button: 'Try again',
  },
};
